<template>
  <!-- 训练模型 -->
  <div class="training-step-model-release">
    <div class="training">
      <div class="intxt">
        <label class="label">
          <i class="required">*</i>选择发布模型：
        </label>
        <el-select
          class="select-box"
          v-model="activeModel"
          placeholder="请选择发布模型"
          filterable
        >
          <el-option
            v-for="item in modelOptions"
            :key="item.modelId"
            :label="item.modelName"
            :value="item.modelId"
          ></el-option>
        </el-select>
      </div>
      <div class="intxt select-box">
        <label class="label">
          <i class="required">*</i>选择模型版本：
        </label>
        <el-select
          class="select-box"
          v-model="activeTrainingModel"
          placeholder="请选择模型版本"
          ref="verify-Model"
          filterable
        >
          <el-option
            v-for="item in versionOptions"
            :key="item.trainModelId"
            :label="item.version"
            :value="item.trainModelId"
          ></el-option>
        </el-select>
      </div>
      <div class="intxt intxt-tips">
        <label class="label">
          <i class="required">*</i>提示：
        </label>
        <span>模型发布后，可在本课程实训项目的”AI-T编辑器（积木模式）-实训模型“查看使用；或复制模型ID在“AI-T编辑器（代码模式）”使用。</span>
      </div>
      <div class="btns">
        <el-button
          type="primary"
          :class="['btn-primary', {'events-disable': teacherOrStudentState ? (withdrawReleaseStatus || releaseStatus) : releaseStatus}]"
          @click="releaseModel"
        >发布模型</el-button>
      </div>
    </div>
    <!-- 模型信息 -->
    <ModelInformationBox
      :trainingId="trainingId"
      :navType="navType"
      :modelType="modelType"
      :modelInformation="modelInformation"
      @toModelTrain="toModelTrain"
      :releaseStatus="releaseStatus"
      :trainModelShow="trainModelShow"
      :quoteModelNum="quoteModelNum"
      @getQuoteModelNum="getQuoteModelNum"
      :withdrawReleaseStatus="withdrawReleaseStatus"
      :teacherOrStudentState="teacherOrStudentState"
    ></ModelInformationBox>
  </div>
</template>

<script>
import bus from "@/utils/bus";

import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js' // 项目标注接口

import ModelInformationBox from './components/ModelInformationBox.vue'

// import { debounce } from 'lodash' // 引入lodash数组函数方法

export default {
  name: "TrainingStepModelRelease",
  components: { ModelInformationBox },
  props: {
    trainingId: {
      type: String,
      default: ''
    },
    navType: {
      type: String,
      default: ''
    },
    modelType: {
      type: String,
      default: ''
    },
    modelOptions: {
      type: Array,
      default: []
    },
    versionOptions: {
      type: Array,
      default: []
    },
    modelInformation: {
      type: Object,
      default: {}
    },
    releaseStatus: {
      type: Boolean,
      default: false
    },
    trainModelShow: {
      type: Boolean,
      default: false
    },
    withdrawReleaseStatus: {
      type: Boolean,
      default: false
    },
    teacherOrStudentState: {
      type: Boolean,
      default: false
    },
    quoteModelNum: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      activeModel: "", // 激活的模型
      activeTrainingModel: "", // 激活的版本
      TrainingModel: [],
    }
  },
  computed: {
  },
  watch: {
    modelOptions: {
      handler(val) {
        if (val && val.length) {
          this.activeModel = val[0].modelId;
        } else {
          this.activeModel = '';
        }
      },
      deep: true,
      immediate: true,
    },
    versionOptions: {
      handler(val) {
        if (val && val.length) {
          this.activeTrainingModel = val[0].trainModelId;
        } else {
          this.activeTrainingModel = '';
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    toModelTrain() {
      this.$emit('toModelTrain');
    },
    getQuoteModelNum() {
      this.$emit('getQuoteModelNum')
    },
    // 发布模型
    releaseModel() {
      let data = {
        editorType: this.modelType,
        trainingId: this.trainingId,
        trainModelId: this.activeTrainingModel
      };

      // 无训练模型信息，直接返回
      if (!this.activeTrainingModel) {
        return;
      }

      let trainModelStatus = this.versionOptions.find(
        item => item.trainModelId === this.activeTrainingModel
      );
      // 判断已有发布模型提示
      if (trainModelStatus.trainModelStatus == 3) {
        if (this.teacherOrStudentState) {
          bus.$emit('addTrainingAssessment'); // 打开设置考核弹窗
        }
        return this.$message.success('此模型已发布!');
      }

      MARKCENTER.releaseTrainModel(data).then(result => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg);
          this.$emit('getTrainModelByModelId');
          if (this.teacherOrStudentState) {
            bus.$emit('addTrainingAssessment'); // 打开设置考核弹窗
          }
        } else {
          this.$message.success(result.returnMsg);
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.training-step-model-release {
  height: 100%;
  padding-top: 24px;
  display: flex;
  justify-content: space-between;

  .training {
    flex: 1;
    height: 100%;
  }
}
.intxt {
  width: 100%;
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &.intxt-tips {
    // color: #F56C6C;
    color: #ec414c;
    font-size: 13px;
    line-height: 36px;
    align-items: initial;
    span {
      flex: 1;
    }
  }
  .label {
    line-height: 36px;
    &.checkbox-label {
      width: 8em;
    }
  }
  .select-box {
    flex: 1;
  }
  .checkbox {
    margin-top: 20px;
  }
  &::v-deep .el-icon-arrow-up:before {
    content: "\e78f";
  }
  &::v-deep {
    .el-input__count {
      line-height: 1.5;
    }
    .el-input__inner,
    .el-textarea__inner {
      width: 100%;
      height: 36px;
      position: relative;
    }
    .el-textarea__inner {
      font-family: sans-serif;
      resize: none;
    }
    .el-input .el-input__count {
        position: absolute;
        top: 72%;
        right: 0.6em;
    }
    .el-input__count {
        position: absolute;
        right: 17px;
        bottom: -18px;
        padding: 0 5px;
    }
    .el-input__icon {
      height: 36px;
      line-height: 36px;
    }
  }
}

.tips {
  margin-top: 20px;
  margin-left: 8em;
  font-size: $font_size;
  line-height: 40px;
  .error {
    border-left: 2px solid #ff6b75;
    background: #fff1f2;
    color: #ec414c;
    & > i {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin: 0 10px;
      background: #fd626c;
      color: #fff;
      font-size: 15px;
      line-height: 16px;
      vertical-align: middle;
      text-align: center;
      transform: rotate(45deg);
      user-select: none;
    }
    b {
      font-weight: normal;
    }
  }
}

.btns {
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
  text-align: center;
  button {
    margin-right: 35px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.btn-primary,
.btn-cancel {
  height: $height_btn;
  padding: 0 25px;
  line-height: $height_btn;
}
.btn-primary {
  border-color: $bgc_btn_primary;
  background-color: $bgc_btn_primary;
  &:hover {
    background-color: $bgc_btn_primary_hover;
    border-color: $bgc_btn_primary_hover;
  }
}
.btn-cancel {
  border-color: $bgc_btn_cancel;
  background-color: $bgc_btn_cancel;
  color: $color_btn_cancel;
  &:hover {
    background-color: $bgc_btn_cancel_hover;
    border-color: $bgc_btn_cancel_hover;
  }
}

</style>